import type { UserRole } from '../../types';

export type CreatableStaffRole = 'driver' | 'call_center' | 'cashier' | 'kitchen' | 'manager' | 'accountant';

const DEVICE_ACTIVATION_ROLES: UserRole[] = ['driver', 'call_center', 'manager', 'accountant'];
const PIN_ROLES: UserRole[] = ['cashier', 'kitchen', 'manager', 'accountant'];
const ASSISTANT_ROLES: UserRole[] = ['admin', 'manager', 'accountant', 'call_center', 'cashier', 'kitchen'];

export const staffHomeRoute = (role: UserRole) => {
  if (role === 'admin') return '/admin';
  if (role === 'manager' || role === 'accountant') return '/staff-workspace';
  if (role === 'driver') return '/driver';
  if (role === 'call_center') return '/call-center';
  if (role === 'cashier') return '/pos';
  if (role === 'kitchen') return '/kitchen';
  return '/';
};

export const staffRoleRequiresPin = (role: UserRole) => PIN_ROLES.includes(role);
export const staffRoleUsesDeviceActivation = (role: UserRole) => DEVICE_ACTIVATION_ROLES.includes(role);
export const staffRoleCanUseAssistant = (role: UserRole) => ASSISTANT_ROLES.includes(role);
export const staffWorkspaceAssistantPage = (role: UserRole) => ({
  accountant: 'reports', cashier: 'pos', kitchen: 'kitchen',
}[role] || 'ops');
